/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import MsDyn365 from '@msdyn365-commerce/core';
import * as React from 'react';
import { IMfrmChatBotViewProps } from './mfrm-chat-bot';
// tslint:disable-next-line: max-func-body-length
export default (props: IMfrmChatBotViewProps) => {
    const [showChat, setShowChat] = React.useState<boolean>(false);
    React.useEffect(() => {
        if (MsDyn365.isBrowser) {
            document.onreadystatechange = () => {
                if (document.readyState === 'complete') {
                    setShowChat(true);
                }
            };
        }
    }, []);

    return (
        <>
            {showChat ? (
                <>
                    <div className='embeddedServiceInvitation' id='snapins_invite' aria-live='assertive' role='dialog' aria-atomic='true'>
                        <div
                            className='embeddedServiceInvitationHeader'
                            aria-labelledby='snapins_titletext'
                            aria-describedby='snapins_bodytext'
                        >
                            <img id='embeddedServiceAvatar' alt='Avatar' />
                            <span className='embeddedServiceTitleText' id='snapins_titletext'>
                                Need help?
                            </span>
                            <button type='button' id='closeInvite' className='embeddedServiceCloseIcon' aria-label='Exit invitation'>
                                &times;
                            </button>
                        </div>
                        <div className='embeddedServiceInvitationBody'>
                            <p id='snapins_bodytext'>
                                Chat with a Sleep Expert&trade; and Save Big! We are here 24/7 to help you find the right mattress at the
                                best price guaranteed.
                            </p>
                        </div>
                        <div className='embeddedServiceInvitationFooter' aria-describedby='snapins_bodytext'>
                            <button type='button' className='embeddedServiceActionButton' id='rejectInvite'>
                                Close
                            </button>
                            <button type='button' className='embeddedServiceActionButton' id='acceptInvite'>
                                Start Chat
                            </button>
                        </div>
                    </div>
                </>
            ) : null}
        </>
    );
};
